<script>export let title = null;
export let metaTitle = null;
export let authorName = "Timo Dechau";
export let publishedDate = null;
export let description = null;
export let metaDescription = null;
export let ogSiteName = "DeepskyData";
export let ogType = "website";
export let ogUrl = null;
export let ogTitle = null;
export let ogDescription = null;
export let ogImage = null;
export let ogImageAlt = "A preview image of a shared DeepskyData link";
export let image = null;
export let ogLocale = "en_US";
$:
  pageTitle = metaTitle ?? `${title} | DeepskyData`;
</script>

<svelte:head>
	{#if pageTitle}
		<title>{pageTitle}</title>
	{/if}
	{#if ogDescription || metaDescription}
		<meta property="og:description" content={ogDescription ?? metaDescription} />
	{/if}
	<meta name="author" content={authorName} />
	{#if publishedDate}
		<meta name="date" property="article:published_time" content={publishedDate} />
	{/if}
	{#if metaDescription || description}
		<meta name="description" content={metaDescription ?? description} />
	{/if}
	<meta property="og:site_name" content={ogSiteName} />
	<meta property="og:type" content={ogType} />
	{#if ogUrl}
		<meta property="og:url" content={ogUrl} />
	{/if}
	{#if ogTitle}
		<meta property="og:title" content={ogTitle} />
	{/if}
	{#if ogImage}
		<meta name="image" property="og:image" content={ogImage} />
	{:else if image}
		<meta name="image" property="og:image" content={image} />
	{/if}
	<meta property="og:image:alt" content={ogImageAlt} />
	<meta property="og:locale" content={ogLocale} />
</svelte:head>
